import { t } from 'i18next';
import React, { useCallback } from 'react';

import UTextLink from 'Components/unit/UTextLink/UTextLink';
import { useAppDispatch } from 'Libs/redux/store';
import { redirect } from 'Libs/routing';
import { sendCommands, useModuleSelector } from 'Pages/Courses/redux';
import { createEditCourseDataCommands } from 'Pages/Courses/utils/commands';

export const ExitAIGeneration: React.FC = () => {
  const dispatch = useAppDispatch();

  const courseId = useModuleSelector((state) => state.edition.course?.id);
  const courseDataId = useModuleSelector((state) => state.edition.course?.dataId);
  const editionId = useModuleSelector((state) => state.edition.revision?.editionId);

  const handleClickOnExit = useCallback(async () => {
    if (courseId && courseDataId && editionId) {
      const commands = createEditCourseDataCommands(courseDataId, {
        aiGenerationStatus: 'MANUAL',
      });

      await dispatch(
        sendCommands({
          id: courseId,
          payload: {
            commands,
            editionId,
          },
        }),
      );
    }

    redirect(`/course/${courseId}/microknowledges`);
  }, [courseId, courseDataId, editionId, dispatch]);

  return (
    <UTextLink
      leftIcon="close-light"
      text={t('aicourse:aiinitial.closePrompt')}
      onClick={handleClickOnExit}
      typography="BODY3_SEMIBOLD"
      colorOverride="#8694AD"
    />
  );
};

export default ExitAIGeneration;
